export enum Role {
  ADMIN = 'app-admin',
  READONLY = 'app-readonly',
}
